import styled from 'styled-components';

const BRAND_COLOR = '#0B2A1B';

export const InvestigationFormWrapper = styled.div`
  width: 100%;
  padding: 24px;

  /* Header */
  .inv-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
  }

  .inv-back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${BRAND_COLOR};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
    margin-bottom: 12px;

    &:hover {
      text-decoration: underline;
    }
  }

  .inv-title {
    font-size: 28px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 4px 0;
  }

  .inv-subtitle {
    font-size: 14px;
    color: #667085;
    margin: 0;
  }

  .inv-header-actions {
    display: flex;
    gap: 12px;
    flex-shrink: 0;
  }

  .btn-save-draft {
    border-color: #d0d5dd;
    color: #344054;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-submit {
    background-color: ${BRAND_COLOR} !important;
    border-color: ${BRAND_COLOR} !important;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      opacity: 0.85;
    }
  }

  .btn-approve {
    background-color: ${BRAND_COLOR} !important;
    border-color: ${BRAND_COLOR} !important;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;

    &:hover {
      opacity: 0.85;
    }
  }

  .btn-request-info {
    border-color: #f04438;
    color: #f04438;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;

    &:hover {
      color: #d92d20;
      border-color: #d92d20;
    }
  }

  /* Progress Stepper */
  .stepper-card {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 24px;
    margin-bottom: 24px;
  }

  .stepper-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .stepper-item {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .stepper-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  .stepper-circle {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
  }

  .stepper-circle-active {
    background: ${BRAND_COLOR};
    color: #fff;
  }

  .stepper-circle-inactive {
    background: #e5e7eb;
    color: #6b7280;
  }

  .stepper-label {
    font-size: 12px;
    font-weight: 600;
    margin-top: 8px;
    text-align: center;
  }

  .stepper-label-active {
    color: ${BRAND_COLOR};
  }

  .stepper-label-inactive {
    color: #6b7280;
  }

  .stepper-desc {
    font-size: 10px;
    color: #9ca3af;
    margin-top: 2px;
    text-align: center;
  }

  .stepper-line {
    height: 2px;
    flex: 1;
    margin-top: 24px;
    transition: background 0.2s ease;
  }

  .stepper-line-active {
    background: ${BRAND_COLOR};
  }

  .stepper-line-inactive {
    background: #e5e7eb;
  }

  /* Form Card */
  .form-card {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 32px;
    margin-bottom: 24px;
  }

  .step-title {
    font-size: 20px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .step-description {
    font-size: 14px;
    color: #667085;
    margin-bottom: 24px;
  }

  .field-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #101828;
    margin-bottom: 8px;
  }

  .field-label-sm {
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: #667085;
    margin-bottom: 8px;
  }

  /* Why Cards */
  .why-card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
  }

  .why-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .why-number {
    background: #f3e8ff;
    color: #6b21a8;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    flex-shrink: 0;
  }

  .why-title {
    font-size: 16px;
    font-weight: 600;
    color: #101828;
  }

  /* Tips Box */
  .tips-box {
    border-radius: 8px;
    padding: 16px;
    margin-top: 24px;
  }

  .tips-box-blue {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
  }

  .tips-box-yellow {
    background: #fefce8;
    border: 1px solid #fde68a;
  }

  .tips-box-title {
    font-size: 12px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .tips-box-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .tips-box-list li {
    font-size: 12px;
    color: #667085;
    margin-bottom: 4px;
  }

  /* Contributing Factor Sections (ICAM) */
  .factor-section {
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
  }

  .factor-section-indigo {
    background: #eef2ff;
    border: 1px solid #c7d2fe;
  }

  .factor-section-purple {
    background: #faf5ff;
    border: 1px solid #e9d5ff;
  }

  .factor-section-blue {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
  }

  .factor-section-green {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
  }

  .factor-section-orange {
    background: #fff7ed;
    border: 1px solid #fed7aa;
  }

  .factor-title {
    font-size: 16px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .factor-desc {
    font-size: 12px;
    color: #667085;
    margin-bottom: 16px;
  }

  .factor-input-row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
  }

  /* Event Timeline (ICAM) */
  .event-card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 16px;
  }

  .event-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .event-title {
    font-size: 16px;
    font-weight: 600;
    color: #101828;
  }

  .event-grid {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 16px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  /* Root Cause Card (ICAM) */
  .root-cause-card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 16px;
  }

  .root-cause-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  /* Corrective Action Card (ICAM) */
  .action-card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 16px;
  }

  .action-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .action-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .priority-group {
    display: flex;
    gap: 16px;
    margin-top: 4px;
  }

  .priority-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
  }

  .priority-high { color: #dc2626; }
  .priority-medium { color: #ea580c; }
  .priority-low { color: #ca8a04; }

  /* Corrective Action Row (5 Whys) */
  .corrective-action-row {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
  }

  /* Navigation */
  .step-nav {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }

  .step-nav-end {
    display: flex;
    gap: 12px;
  }

  /* Review Section */
  .review-section {
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
  }

  .review-title {
    font-size: 18px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .review-status {
    font-size: 14px;
    color: #667085;
    margin-bottom: 16px;
  }

  .review-actions {
    display: flex;
    gap: 12px;
    margin-top: 16px;
  }

  /* Readonly state */
  .readonly-notice {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 24px;
    font-size: 14px;
    color: #166534;
    font-weight: 500;
  }

  /* Delete button */
  .btn-delete-icon {
    color: #dc2626;
    border: none;
    background: none;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover {
      background: #fef2f2;
    }
  }

  /* Shared form inputs */
  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 8px !important;
  }

  textarea.ant-input {
    border-radius: 8px !important;
  }

  .ant-select-selector {
    border-radius: 8px !important;
  }

  .ant-btn {
    border-radius: 8px;
  }

  /* Loading */
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .not-found-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .not-found-title {
    font-size: 24px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }

  .not-found-link {
    color: ${BRAND_COLOR};
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    .inv-header {
      flex-direction: column;
    }

    .inv-header-actions {
      width: 100%;
      justify-content: flex-start;
    }

    .stepper-label,
    .stepper-desc {
      display: none;
    }
  }
`;
